import { render } from "./DonationGroupManageListForm.vue?vue&type=template&id=efcea20e&lang=true"
import script from "./DonationGroupManageListForm.vue?vue&type=script&lang=js"
export * from "./DonationGroupManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__